/*
 * Copyright (c) GM Global Technology Operations LLC. All rights reserved.
 * This information is confidential and proprietary to GM Global Technology
 * Operations LLC and may not be used, modified, copied or distributed.
 */

import { Alert, Typography } from '@mui/material';
import {
  MotorsportsError,
  MotorsportsErrorFallbackProps,
  MotorsportsErrorType,
} from 'services/motorsportsError/MotorsportsError';
import { authService } from 'services/auth/AuthService';
import { Link } from '@mui/material';

const getErrorElement = (error: MotorsportsError) => {
  switch (error.type) {
    case MotorsportsErrorType.Unauthenticated:
      return (
        <Typography variant="inherit" sx={{ textDecoration: 'none' }}>
          Your session has expired.{' '}
          <Link color="inherit" onClick={() => authService.startAuthentication()} sx={{ cursor: 'pointer' }}>
            Please log in.
          </Link>
        </Typography>
      );
    case MotorsportsErrorType.SessionNotFound:
      return (
        <Typography variant="inherit">
          Session "{error.message}" not found.{' '}
          <Link href="/" color="inherit">
            Try selecting another.
          </Link>
        </Typography>
      );
    case MotorsportsErrorType.ImageNotFound:
      return (
        <Typography variant="inherit">
          Image not found.
        </Typography>
      );
      default:
      return <>{error.message || 'Runtime exception occured. Try again or contact your system adminstator.'}</>;
  }
};

export const ErrorFallback = ({ error }: MotorsportsErrorFallbackProps) => {
  const errorElement = getErrorElement(error);
  return (
    <Alert severity="error" variant="filled" sx={{ m: '1rem' }}>
      {errorElement}
    </Alert>
  );
};
